export class MediaQueries {
  static readonly MIN_WIDTH_1 = '(min-width: 1px)'
  static readonly MAX_WIDTH_499 = '(max-width: 499px)'
  static readonly MIN_WIDTH_500 = '(min-width: 500px)'
  static readonly MAX_WIDTH_575 = '(min-width: 575px)'
  static readonly MAX_WIDTH_767 = '(max-width: 767px)'
  static readonly MIN_WIDTH_768 = '(min-width: 768px)'
  static readonly MAX_WIDTH_991 = '(max-width: 991px)'
  static readonly MIN_WIDTH_992 = '(min-width: 992px)'
  static readonly MAX_WIDTH_1199 = '(max-width: 1199px)'
  static readonly MIN_WIDTH_1200 = '(min-width: 1200px)'
  static readonly BETWEEN_500_767 = '(min-width: 500px) and (max-width: 767px)'
  static readonly BETWEEN_576_767 = '(min-width: 576px) and (max-width: 767px)'
  static readonly BETWEEN_768_991 = '(min-width: 768px) and (max-width: 991px)'
  static readonly BETWEEN_992_1199 = '(min-width: 992px) and (max-width: 1199px)'
}
